import { render, staticRenderFns } from "./lablePop.vue?vue&type=template&id=1933799a&scoped=true&"
import script from "./lablePop.vue?vue&type=script&lang=js&"
export * from "./lablePop.vue?vue&type=script&lang=js&"
import style0 from "./lablePop.vue?vue&type=style&index=0&id=1933799a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933799a",
  null
  
)

export default component.exports